import { cn } from '@/shared/utils/cn';

interface TemplateQuestionButtonProps {
  question: string;
  onClick: () => void;
  className?: string;
  disabled?: boolean;
}

export function TemplateQuestionButton({
  question,
  onClick,
  className,
  disabled = false,
}: TemplateQuestionButtonProps) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={cn(
        'flex w-full flex-col gap-3',
        'justify-start rounded-lg border-zinc-200 bg-white p-6 text-left hover:bg-zinc-50 focus:bg-zinc-50',
        'shadow-sm',
        disabled && 'cursor-not-allowed opacity-50',
        className,
      )}
    >
      <p className="text-muted-foreground text-sm font-normal">{question}</p>
    </button>
  );
}
